<template>
  <b-container class="mt-12">
    <b-row class="justify-content-md-center">
      <form @submit.prevent="login">
        <h3>路邊停車單據中心</h3>

        <div class="form-group">
          <label>Account</label>
          <input
            type="text"
            class="form-control form-control-lg"
            v-model="user.account"
          />
        </div>  

        <div class="form-group">
          <label>Password</label>
          <input
            type="password"
            class="form-control form-control-lg"
            v-model="user.password"
          />
        </div>

        <button type="submit" class="btn btn-dark btn-lg btn-block">
          登入
        </button>
      </form>
    </b-row>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      user: { account: "", password: "" },
    };
  },
  mounted() {
    if (this.$store.state.user != null) {
        if (this.$store.state.user.role === '遊客') {
          this.$router.push({ path: "search" });
        } else {
          this.$router.push({ path: "home" });
        }
    }
  },
  methods: {
    login() {
      this.axios.post('api/login', {
        account: this.user.account,
        password: this.user.password,
      }).then((resp) => {
        if (resp.data.msg)  {
          alert('帳號密碼錯誤');

          this.user.account = "";
          this.user.password = "";

          return;
        }

        this.$store.commit('SetUser', {
          id: resp.data.id,
          name: resp.data.name,
          account: resp.data.account,
          role: resp.data.role
        })
        this.$store.commit('SetAuthToken', resp.data.token)
        
        // sessionStorage.setItem('user', resp.data.id);
        this.$store.commit('SetLoaded')
        // this.$store.commit('SetRole', resp.data.role);

        if (resp.data.role === '遊客') {
          this.$router.push({ path: "search" });
        } else {
          this.$router.push({ path: "home" });
        }
      });
    },
  },
};
</script>
